//GeneratorFlag:[NoChange]
import StaticPage from './static-page';
import StaticPageFilter from './static-page-filter';

export default {StaticPage, StaticPageFilter}
export{StaticPage, StaticPageFilter}